import { CSSProperties } from 'react'
import styled from 'styled-components'

export const annotationsspec: {
  [key: string]: AnnotationSpec
} = {
  kiew: {
    label_de: 'Kiew',
    label_fr: 'Kiev',
    position: { x: 57.5, y: 30 },
    position_mob: { x: 51, y: 31 },
    type: '_point_bottom_center',
  },
  cherniv: {
    label_de: 'Cherniv',
    label_fr: 'Chernivtsi',
    position: { x: 56.5, y: 28 },
    position_mob: { x: 12, y: 24 },
    type: 'city',
  },
  mariupol: {
    label_de: 'Mariupol',
    label_fr: 'Marioupol',
    position: { x: 86.75, y: 65 },
    position_mob: { x: 85, y: 57 },
    type: '_point_bottom_left',
  },
  cherson: {
    label_de: 'Cherson',
    label_fr: 'Cherson',
    position: { x: 66.5, y: 70 },
    position_mob: { x: 61, y: 60 },
    type: '_point_bottom_left',
  },
  charkiw: {
    label_de: 'Charkiw',
    label_fr: 'Kharkiv',
    position: { x: 81, y: 35.5 },
    position_mob: { x: 79, y: 34 },
    type: '_point_bottom_center',
  },
  sumy: {
    label_de: 'Sumi',
    label_fr: 'Sumy',
    position: { x: 75, y: 25.5 },
    position_mob: { x: 72, y: 27 },
    type: '_point_bottom_center',
  },
  dnipro: {
    label_de: 'Dnipro',
    label_fr: 'Dnipropetrovsk',
    position: { x: 76, y: 52 },
    position_mob: { x: 74, y: 47 },
    type: '_point_bottom_center',
  },
  odessa: {
    label_de: 'Odessa',
    label_fr: 'Odessa',
    position: { x: 59, y: 72 },
    position_mob: { x: 50.5, y: 46.5 },
    type: '_point_bottom_center',
  },
  kramatorsk: {
    label_de: 'Kramatorsk',
    label_fr: 'Kramatorsk',
    position: { x: 87, y: 49 },
    position_mob: { x: 85.5, y: 45 },
    type: '_point_bottom_center',
  },
  berdjansk: {
    label_de: 'Berdjansk',
    label_fr: 'Berdjansk',
    position: { x: 86, y: 66 },
    position_mob: { x: 84, y: 58 },
    type: '_point_bottom_center',
  },
  mykolajiw: {
    label_de: 'Mikolajiw',
    label_fr: 'Mykolajiw',
    position: { x: 64, y: 67 },
    position_mob: { x: 58, y: 58.5 },
    type: '_point_top_left',
  },
  krim: {
    label_de: 'Krim',
    label_fr: 'Crimea',
    position: { x: 74, y: 84 },
    position_mob: { x: 72, y: 71 },
    type: 'region',
  },
  donezk: {
    label_de: 'Donezk',
    label_fr: 'Donetsk',
    position: { x: 89, y: 50 },
    position_mob: { x: 90, y: 49 },
    type: 'region',
  },
  luhansk: {
    label_de: 'Luhansk',
    label_fr: 'Luhansk',
    position: { x: 94, y: 42 },
    position_mob: { x: 96, y: 40 },
    type: 'region',
  },
  blacksea: {
    label_de: 'Schwarzes Meer',
    label_fr: 'Mer Noire',
    position: { x: 66, y: 94 },
    position_mob: { x: 85, y: 88 },
    type: 'region',
  },
  butcha: {
    label_de: 'Butscha',
    label_fr: 'Butcha',
    position: { x: 56.5, y: 29.5 },
    position_mob: { x: 50, y: 30 },
    type: 'city',
  },
  //
  //
  //
  russia: {
    label_de: 'Russland',
    label_fr: 'Russie',
    position: { x: 90, y: 18 },
    position_mob: { x: 90, y: 18 },
    type: 'country',
  },
  belarus: {
    label_de: 'Weissrussland',
    label_fr: 'Biélorussie',
    position: { x: 45, y: 8 },
    position_mob: { x: 42, y: 12 },

    type: 'country',
  },
  poland: {
    label_de: 'Polen',
    label_fr: 'Pologne',
    position: { x: 15, y: 18 },
    position_mob: { x: 14, y: 22 },

    type: 'country',
  },
  slowakia: {
    label_de: 'Slowakei',
    label_fr: 'Slovaquie',
    position: { x: 15, y: 47 },
    type: 'country',
  },
  hungary: {
    label_de: 'Ungarn',
    label_fr: 'Hongrie',
    position: { x: 10, y: 67 },
    type: 'country',
  },
  romania: {
    label_de: 'Rumänien',
    label_fr: 'Roumanie',
    position: { x: 30, y: 77 },
    position_mob: { x: 30, y: 70 },

    type: 'country',
  },
  moldova: {
    label_de: 'Moldawien',
    label_fr: 'Moldavie',
    position: { x: 52.3, y: 59 },
    type: 'country',
  },
}

export const Annotation = ({
  anno,
  lang = 'de',
}: {
  anno: AnnotationSpec
  lang?: 'de' | 'fr'
}) => {
  const label = anno[`label_${lang}`]
  const position = window.innerWidth > 711 ? anno.position : anno.position_mob
  if (!position) return null

  let type = anno.type
  let arrow = type.includes('_arrow')
  let blue = type.includes('_blue')
  let grey = type.includes('_grey')
  let curved = type.includes('_curved')
  let hidearrow = type.includes('hidearrow')
  let point = type.includes('point')
  let circle = type.includes('circle')
  let center = type.includes('center')
  let right = type.includes('right')
  let left = type.includes('left')
  let bg = type.includes('bg')
  let bottom = type.includes('bottom')
  let country = type.includes('country')
  let region = type.includes('region')
  let bomb = type.includes('bomb')
  let istop = type.includes('top')
  let bold = type.includes('bold')

  type = type.replace('_bg', '')
  type = type.replace('_center', '')
  type = type.replace('_country', '')
  type = type.replace('_arrow', '')
  type = type.replace('_point', '')
  type = type.replace('_bottom', '')
  type = type.replace('_top', '')

  let xMove = center ? -50 : left ? 0 : -100

  let yMove = bg ? 15 : bottom ? 0 : -5
  let arrowXmov = center ? -10 : left ? 0 : -20
  let arrowYmov = center ? -5 : bottom ? 5 : -25

  let countrystyle = {
    textTransform: 'uppercase',
    fontWeight: '300',
    letterSpacing: '1px',
    fontSize: '14px',
    color: 'var(--brandblue-main)',
    opacity: 0.3,
  }

  let regionsstyle = {
    fontStyle: 'italic',
    color: 'var(--brandblue-main)',
    opacity: 0.5,
  }

  let style = country ? countrystyle : region ? regionsstyle : {}

  const rad = anno.radius || 10
  if (arrow) {
    const rotation = anno.rotation || 0
    const color = blue ? 'blue' : grey ? 'grey' : 'red'
    return (
      <Position style={{ top: position.y + '%', left: position.x + '%' }}>
        <PositionArrow
          style={{ transform: 'rotate(' + rotation + 'DEG)' }}
          type={curved ? (left ? 'curve_left' : 'curve_right') : 'straight'}
          color={color}
        />
      </Position>
    )
  }
  if (circle) {
    return (
      <RegionCircle
        style={{
          top: position.y + '%',
          left: position.x + '%',
          width: rad + 'vw',
          height: rad + 'vw',
        }}
      />
    )
  }
  return (
    <Position style={{ top: position.y + '%', left: position.x + '%' }}>
      {point && !bomb && <Circle />}
      {point && bomb && <ExplosionIcon />}

      <Label
        style={{
          transform: istop
            ? 'translate(' + xMove + '%, calc(-100% - ' + yMove + 'px))'
            : bottom
            ? 'translate(' + xMove + '%, ' + yMove + 'px)'
            : 'translate(' + xMove + '%, -50%)',
          backgroundColor: bg ? 'var(--brandblue-bright-2)' : 'unset',
          color: bg ? '#fff' : 'var(--brandblue-main)',
          ...style,
          fontWeight: bold ? 700 : 400,
        }}
      >
        {label}
      </Label>
      {bg && !hidearrow && (
        <Arrow
          style={{
            left: arrowXmov + 'px',
            top: arrowYmov + 'px',

            borderTopColor: 'transparent',
            borderBottomColor:
              center && !right && !left
                ? 'var(--brandblue-bright-2)'
                : 'transparent',
            borderRightColor: right ? 'var(--brandblue-bright-2)' : 'transparent',
            borderLeftColor: left ? 'var(--brandblue-bright-2)' : 'transparent',
          }}
        />
      )}
    </Position>
  )
}

const PositionArrow = ({
  style,
  type,
  color,
}: {
  style: CSSProperties
  type: 'curve_left' | 'curve_right' | 'straight'
  color: string
}) => {
  return (
    <PositionArrowRoot style={style}>
      <img
        src={require('../../assets/arrows_' + type + '_' + color + '.png')}
      />
    </PositionArrowRoot>
  )
}

const PositionArrowRoot = styled.div`
  img {
    width: 40px;
    max-width: 100%;
    height: unset !important;
    min-height: unset !important;
    min-width: unset !important;
    max-height: unset !important;

    @media screen and (max-width: 711px) {
      width: 30px;
    }
  }
`

const Position = styled.div`
  position: absolute;
`

const Label = styled.div`
  display: inline-block;
  background-color: #f00;
  font-family: var(--font-plex);
  font-size: 15px;
  white-space: nowrap;
  padding: 5px 10px;
  line-height: 2em;
  @media screen and (max-width: 711px) {
    font-size: 12px;
  }
`

const Circle = styled.div`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background-color: var(--brandblue-main);
  position: absolute;
  left: -3px;
  top: 0;
`

const ExplosionIcon = () => {
  return (
    <IconSvg
      viewBox='0 0 100 60'
      width={30}
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate(-50%, -7px)',
      }}
    >
      <path
        d='m85.04,47.15l12.58-18.39c.12-.12.12-.47,0-.59-.12-.24-.35-.35-.59-.35l-21.05,1.89,1.76-21.57c0-.24-.12-.47-.35-.59-.24-.12-.47-.12-.59,0l-17.41,12.38L50.35.35c-.12-.24-.24-.35-.47-.35s-.47.12-.47.35l-9.06,19.57L23.07,7.66c-.12-.12-.47-.12-.59,0-.24.12-.35.35-.24.59l1.76,21.57-21.17-1.89c-.24,0-.47.12-.59.35-.12.24-.12.47,0,.59l12.58,18.39L0,60h8.72l22.46-8.96-6.12-8.96c-.12-.12-.12-.35,0-.59.12-.12.35-.24.59-.24l10.7.94-.94-10.73c-.12-.24,0-.47.24-.59.12-.12.35-.12.59,0l8.7,6.13,4.47-9.78c.23-.35.94-.35,1.06,0l4.47,9.67,8.7-6.25c.12-.12.35-.12.59,0,.24.12.35.35.35.59l-.94,10.73,10.82-.71c.24-.12.47,0,.59.24.12.12.12.47,0,.59l-6.12,8.96,22.46,8.84,8.61.12-14.96-12.85Z'
        fill='var(--red-main)'
      />
    </IconSvg>
  )
}
const ArrowIcon = ({
  style,
  dir = 'left',
}: {
  style?: CSSProperties
  dir?: 'left' | 'right'
}) => {
  return (
    <IconSvg viewBox='0 0 580.42 615.42' width={30} style={style}>
      <defs>
        <linearGradient
          id='aaa'
          data-name='Unbenannter Verlauf 6'
          x1='547.03'
          y1='10.25'
          x2='134.85'
          y2='418.47'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='var(--red-main)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--red-main)' />
        </linearGradient>
      </defs>
      <path
        d={
          dir === 'left'
            ? 'm386.67,39.13c-59.27,25.07-112.5,60.95-158.19,106.65-45.7,45.7-81.58,98.92-106.65,158.19-25.96,61.38-39.13,126.57-39.13,193.74H0l117.7,117.7,117.7-117.7h-82.7c0-57.76,11.3-113.77,33.6-166.47,21.54-50.93,52.39-96.67,91.68-135.96,39.29-39.29,85.04-70.14,135.96-91.68,52.71-22.29,108.72-33.6,166.48-33.6V0c-67.18,0-132.36,13.16-193.74,39.13Z'
            : 'm193.74,39.13c59.27,25.07,112.5,60.95,158.19,106.65,45.7,45.7,81.58,98.92,106.65,158.19,25.96,61.38,39.13,126.57,39.13,193.74h82.7s-117.7,117.7-117.7,117.7l-117.7-117.7h82.7c0-57.76-11.3-113.77-33.6-166.47-21.54-50.93-52.39-96.67-91.68-135.96-39.29-39.29-85.04-70.14-135.96-91.68C113.77,81.3,57.76,70,0,70V0c67.18,0,132.36,13.16,193.74,39.13Z'
        }
        fill='url(#aaa)'
      />
    </IconSvg>
  )
}
const ArrowIconStraight = ({
  style,
  dir = 'left',
}: {
  style?: CSSProperties
  dir?: 'left' | 'right'
}) => {
  return (
    <IconSvg viewBox='0 0 235.41 794.68' width={30} style={style}>
      <defs>
        <linearGradient
          id='Unbenannter_Verlauf_6'
          data-name='Unbenannter Verlauf 6'
          x1='319.88'
          y1='156.01'
          x2='-14.67'
          y2='487.34'
          gradientTransform='translate(235.41) rotate(-180) scale(1 -1)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#202346' stopOpacity='0' />
          <stop offset='1' stopColor='#202346' />
        </linearGradient>
      </defs>
      <polyline
        points='34.7 0 82.7 676.98 0 676.98 117.7 794.68 235.41 676.98 152.7 676.98 200.7 0'
        fill='url(#Unbenannter_Verlauf_6)'
      />
    </IconSvg>
  )
}
const ArrowIconBlue = ({
  style,
  dir = 'left',
}: {
  style?: CSSProperties
  dir?: 'left' | 'right'
}) => {
  return (
    <IconSvg viewBox='0 0 580.42 615.42' width={30} style={style}>
      <defs>
        <linearGradient
          id='aaa'
          data-name='Unbenannter Verlauf 6'
          x1='547.03'
          y1='10.25'
          x2='134.85'
          y2='418.47'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='var(--blue-main)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--blue-main)' />
        </linearGradient>
      </defs>
      <path
        d={
          dir === 'left'
            ? 'm386.67,39.13c-59.27,25.07-112.5,60.95-158.19,106.65-45.7,45.7-81.58,98.92-106.65,158.19-25.96,61.38-39.13,126.57-39.13,193.74H0l117.7,117.7,117.7-117.7h-82.7c0-57.76,11.3-113.77,33.6-166.47,21.54-50.93,52.39-96.67,91.68-135.96,39.29-39.29,85.04-70.14,135.96-91.68,52.71-22.29,108.72-33.6,166.48-33.6V0c-67.18,0-132.36,13.16-193.74,39.13Z'
            : 'm193.74,39.13c59.27,25.07,112.5,60.95,158.19,106.65,45.7,45.7,81.58,98.92,106.65,158.19,25.96,61.38,39.13,126.57,39.13,193.74h82.7s-117.7,117.7-117.7,117.7l-117.7-117.7h82.7c0-57.76-11.3-113.77-33.6-166.47-21.54-50.93-52.39-96.67-91.68-135.96-39.29-39.29-85.04-70.14-135.96-91.68C113.77,81.3,57.76,70,0,70V0c67.18,0,132.36,13.16,193.74,39.13Z'
        }
        fill='url(#aaa)'
      />
    </IconSvg>
  )
}
const ArrowIconRight = ({
  style,
  dir = 'left',
}: {
  style?: CSSProperties
  dir?: 'left' | 'right'
}) => {
  return (
    <IconSvg viewBox='0 0 580.42 615.42' width={30} style={style}>
      <defs>
        <linearGradient
          id='Unbenannter_Verlauf_6'
          data-name='Unbenannter Verlauf 6'
          x1='547.03'
          y1='10.25'
          x2='134.85'
          y2='418.47'
          gradientTransform='translate(580.42) rotate(-180) scale(1 -1)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='var(--red-main)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--red-main)' />
        </linearGradient>
      </defs>
      <path
        d='m193.74,39.13c59.27,25.07,112.5,60.95,158.19,106.65,45.7,45.7,81.58,98.92,106.65,158.19,25.96,61.38,39.13,126.57,39.13,193.74h82.7s-117.7,117.7-117.7,117.7l-117.7-117.7h82.7c0-57.76-11.3-113.77-33.6-166.47-21.54-50.93-52.39-96.67-91.68-135.96-39.29-39.29-85.04-70.14-135.96-91.68C113.77,81.3,57.76,70,0,70V0c67.18,0,132.36,13.16,193.74,39.13Z'
        fill='url(#Unbenannter_Verlauf_6)'
      />
    </IconSvg>
  )
}
const ArrowIconRightBlue = ({
  style,
  dir = 'left',
}: {
  style?: CSSProperties
  dir?: 'left' | 'right'
}) => {
  return (
    <IconSvg viewBox='0 0 580.42 615.42' width={30} style={style}>
      <defs>
        <linearGradient
          id='Unbenannter_Verlauf_6'
          data-name='Unbenannter Verlauf 6'
          x1='547.03'
          y1='10.25'
          x2='134.85'
          y2='418.47'
          gradientTransform='translate(580.42) rotate(-180) scale(1 -1)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='var(--blue-main)' stopOpacity='0' />
          <stop offset='1' stopColor='var(--blue-main)' />
        </linearGradient>
      </defs>
      <path
        d='m193.74,39.13c59.27,25.07,112.5,60.95,158.19,106.65,45.7,45.7,81.58,98.92,106.65,158.19,25.96,61.38,39.13,126.57,39.13,193.74h82.7s-117.7,117.7-117.7,117.7l-117.7-117.7h82.7c0-57.76-11.3-113.77-33.6-166.47-21.54-50.93-52.39-96.67-91.68-135.96-39.29-39.29-85.04-70.14-135.96-91.68C113.77,81.3,57.76,70,0,70V0c67.18,0,132.36,13.16,193.74,39.13Z'
        fill='url(#Unbenannter_Verlauf_6)'
      />
    </IconSvg>
  )
}

const RegionCircle = styled.div`
  width: 100px;
  height: 100px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: inline-block;
  border: 3px dotted var(--red-main);
  position: absolute;

  @media screen and (max-width: 711px) {
    border: 2px dotted var(--red-main);
  }
`
const BaseAnnotation = styled.div`
  position: absolute;
  font-family: var(--font-plex);
  font-size: 15px;
  @media screen and (max-width: 711px) {
    font-size: 12px;
  }
`

const Icon = styled(BaseAnnotation)``

const IconSvg = styled.svg`
  position: absolute;
  bottom: -30px;
  left: calc(50% - 15px);
`

const Region = styled(BaseAnnotation)`
  font-style: italic;
  color: rgba(0, 0, 0, 0.6);
`
const Country = styled(BaseAnnotation)`
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: var(--brandblue-bright-3);
`
const City = styled(BaseAnnotation)``
const Bg = styled(BaseAnnotation)`
  width: 100px;
  display: inline-block;
  background-color: var(--brandblue-main);
  transform: translate(0%, -100%);
  text-align: left;
  line-height: 1.2em;
  padding-left: 10px;
  padding-right: 10px;
`
const CityImportant = styled(BaseAnnotation)`
  font-weight: 700;
`

const Label2 = styled.div`
  text-align: left;
  color: #fff;
  width: 100%;
  display: inline-block;
  padding: 10px 0;
  position: relative;
`

const Arrow = styled.div`
  position: absolute;
  top: -10px;
  left: 0;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid transparent;
  border-left: 10px solid var(--brandblue-main);
`
const ArrowRight = styled.div`
  position: absolute;
  top: -10px;
  right: 0;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid var(--brandblue-main);
`
const Circle2 = styled.div`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background-color: var(--brandblue-main);
  position: absolute;
  left: -3px;
  bottom: -17px;
`

const LabelBottom = styled.div`
  position: absolute;

  transform: translateX(-50%);
`
const CircleBottom = styled.div`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background-color: var(--brandblue-main);
  position: absolute;
  left: 0;
  top: -18px;
`
